<template>
  <article class="content ignore-top" id="content">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
    <commen-foot id="foot"></commen-foot>
    <ICP></ICP>
    <back-top/>
  </article>
</template>
<script>
import commenFoot from "@/components/Foot";
import ICP from "@/components/ICP";
import BackTop  from "@/components/BackTop.vue";
import {singleAccountSever} from "@/common/api-config";
import store from '../store'
export default {
  components: {
    commenFoot,ICP,BackTop
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.content {
  position: relative;
  min-height: calc(100vh - 64px);
  background-color: #FAFAFA;
}
.ignore-top {
  margin-top: 64px;
}


@media screen and (max-width: 800px) {
  .content {
    margin-top: 105px;
  }
}
</style>

